import fetch from "@lib/fetch";

import { reactQueryPostWebsocketAdapter } from "../reactQueryFetcherAdapters";
import { appGroupIdComparePreviewsAi } from "./constants";
import type { PostwsAppGroupIdComparePreviewsAiPayload, PostwsAppGroupIdComparePreviewsAiProps } from "./types";
import { isAiPreviewComparisonResult } from "./validators";

export const postwsAppGroupIdComparePreviewsAi = reactQueryPostWebsocketAdapter(
  appGroupIdComparePreviewsAi,
  async (signal, { appGroupId, args, jobToken }: PostwsAppGroupIdComparePreviewsAiProps): Promise<{}> => {
    const payload: PostwsAppGroupIdComparePreviewsAiPayload = {
      job_token: jobToken,
      args,
    };

    return await fetch(`/${appGroupId}/compare_previews_ai`, "POST", payload, { signal });
  },
  isAiPreviewComparisonResult
);
